import API from '@services/API';

const AjudaService = {	
	listar: async () => await API.list(`ajuda`),
	
	buscar: async (id) => await API.get(`ajuda/${id}`),

	editar: async (id, ajuda) => await API.edit(`ajuda`, id, ajuda),
}

export default AjudaService;